import React from 'react';

import './styles.scss';

export interface PageCurvedContainerProps {
  verticalAlignment?: string;
}

const PageCurvedContainer = ({ verticalAlignment, children }: React.PropsWithChildren<PageCurvedContainerProps>) => {
  return (
    <div className="page-curved-container">
      <div className="page-content-curve"></div>
      <div className={`page-content-curved-container ${verticalAlignment === 'center' && 'vertically-centered'}`}>
        <div className="page-content-container">{children}</div>
      </div>
    </div>
  );
};

export default PageCurvedContainer;
